import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const AdmissionProcedure = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Admission Procedure"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Admission Procedure" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="section-title mb-4 pr-lg-5 px-4 px-lg-2">
              <h2 class="title"><span class="text-primary">Admission Procedure</span></h2>
                <div className="curved-line mx-auto mt-3"></div>
            </div>            
          </div>          
        </div>
      </div>

      <div class="section-gap">
          <div class="container mt-4 pb-3">
              <div class="row border-g">
                <div class="col-md-12 col-lg-12 col-xl-12 col-sm-12">
                    <div class="about_section1">
                      <ul class="ad">
                          <li>Application for admission is made to the principal of the concerned branch on a prescribed form.</li>
                          <li>Admission to any class except pre-primary is made after a pre-admission test, and on production of a valid transfer
                            certificate from the previous institution.
                          </li>
                          <li>Admission to pre-primary classes and play group is made according to the age of the child : 2-3 year of age for playgroup
                            (Montessori); 4 year of age for Nursery and 5 year of age for the preparatory. A child's ability is also taken into
                            consideration.
                          </li>
                      </ul>
                    </div>
                </div>
              </div>
              <div class="divider">
              </div>
              <div class="row border-g">
                <div class="col-md-12 col-lg-12 col-xl-12 col-sm-12">
                    <h3> GENERAL RULES </h3>
                    <ul class="ad">
                      <li>Students of all classes should attend prayer meetings in the morning. Students coming late may not be allowed to enter
                          the class without the principal's permission.
                      </li>
                      <li>Parents or their servants are not allowed to enter any class-room.</li>
                      <li>No child should be absent without a prior written leave application. In case of contagion illness, the child is not
                          allowed to attend school without a fitness certificate from an authorised medical practitioner..
                      </li>
                      <li>The school does not accept responsibility for loss of books, money, clothes and other Items belonging the student.
                          Each child is responsible for his/her own belongings.
                      </li>
                      <li>Every child is expected to contribute to the values and standards of the school by his/her conduct.</li>
                      <li>Students should keep their bicycles at the school cycle stand properly locked. School authorities will not be held
                          responsible for any loss of unlocked cycles kept in the cycle stand.
                      </li>
                      <li>No child is allowed to bring mobile phone. Use of motor cycle or moped without a valid driving licence from government
                          .
                      </li>
                      <li>It is compulsory for students to participate in school function, sports cultural and literary activities.</li>
                      <li>No child will be allowed to leave school during, school hours. In exceptional circumstances, the child will be allowed
                          to go with the permission of the principal and accompanied by his/her parents.
                      </li>
                      <li>No jewellery is to be worn ( except a wrist watch) and no make-up of any kind is to be used. Nails are to be kept trimmed.</li>
                    </ul>
                </div>
              </div>
          </div>
        </div>
    </section>
    </>
  )
}

export default AdmissionProcedure
